import { render, staticRenderFns } from "./ProductAdditionalInfo.vue?vue&type=template&id=125d978f&"
import script from "./ProductAdditionalInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductAdditionalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports